import { render, staticRenderFns } from "./topicLIstItem.vue?vue&type=template&id=3935043a&scoped=true"
import script from "./topicLIstItem.vue?vue&type=script&lang=js"
export * from "./topicLIstItem.vue?vue&type=script&lang=js"
import style0 from "./topicLIstItem.vue?vue&type=style&index=0&id=3935043a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3935043a",
  null
  
)

export default component.exports